import styled from "styled-components";
import { Input } from "../../../../../components/Input/input";
import { theme } from "../../../../../helpers/theme";

interface AdditionalCommentsProps {
  formik: any;
}

const AdditionalComments = ({ formik }: AdditionalCommentsProps) => {
  return (
    <AdditionalCommentsContainer>
      <AdditionalCommentsHeader>Dodatkowe uwagi</AdditionalCommentsHeader>
      <AdditionalCommentsInputWrapper>
        <Input
          label="Zacznij pisać..."
          id="additionalComments"
          name="additionalComments"
          value={formik.values.additionalComments}
          onChange={formik.handleChange}
          error={
            formik.touched.additionalComments &&
            Boolean(formik.errors.additionalComments)
          }
          helperText={
            formik.touched.additionalComments &&
            formik.errors.additionalComments
          }
          onBlur={formik.handleBlur}
          variant="filled"
          sx={{
            width: "100%",
          }}
        />
      </AdditionalCommentsInputWrapper>
    </AdditionalCommentsContainer>
  );
};

export default AdditionalComments;
const AdditionalCommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;
const AdditionalCommentsHeader = styled.h3`
  font-family: ${theme.fonts.interBold};
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: black;
  margin-bottom: 16px;
  margin-left: 4px;
`;
const AdditionalCommentsInputWrapper = styled.div`
  display: flex;
  width: 100%;
`;
